import request from '@/utils/request'

export function captcha() {
    return request({
        url: 'captcha',
        method: 'post',
    })
}

export function login(data) {
    return request({
        url: 'login',
        method: 'post',
        data
    })
}

export function logout() {
    return request({
        url: 'logout',
        method: 'post'
    })
}

export function getList(data) {
    return request({
        url: 'user/index',
        method: 'post',
        data
    })
}

export function selectIndex(data) {
    return request({
        url: '/user/selectIndex',
        method: 'post',
        data
    })
}



export function add(data) {
    return request({
        url: 'user/add',
        method: 'post',
        data
    })
}

export function edit(data) {
    return request({
        url: 'user/edit',
        method: 'post',
        data
    })
}

export function del(data) {
    return request({
        url: 'user/del',
        method: 'post',
        data
    })
}
